<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        @save="$refs.Form.validate(save)"
        button-cancel-text="Cancelar"
        ref="Modal"
        title="Desativação"
    >
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :maxlength="validations.max"
                        :validations="validations.motivo"
                        label="Motivo"
                        rows="5"
                        v-model="model.motivoInativacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-modal>
</template>

<script>
// Mixins.
import { object, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {
            return {
                motivo: { required: true, max: 500 },
            }
        }
    },
    data: () => ({
        model: {
            motivoInativacao: null,
        },
        onConfirm: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(onConfirm) {
            this.resetForm()

            this.onConfirm = onConfirm

            this.$refs.Modal.show()
        },
        save() {
            this.setLoading()

            this.onConfirm(this.clone(this.model))
                .then(() => this.$refs.Modal.hide())
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        resetForm() {
            this.model.motivoInativacao = null
        },
    },
    mixins: [object, error],
}
</script>